
//==================BEGIN DEPENDENCIES========================

import 'jquery';
  
import 'reflect-metadata';
  

//==================BEGIN UTILITY========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/utility/namespace/namespace';
  
import ManageUserMouse from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/utility/a11y/a11y';  

//==================BEGIN PLUGINS========================

import Truncate from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/node_modules/ui-theme/plugins/authors-truncate/index';  
import A11y from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/plugins/a11y/a11y';  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/node_modules/ui-theme/plugins/breakPointEvents/index';
  
import SelectableDropdown from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/plugins/selectableDropdown/index';  
import Parallax from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/node_modules/ui-theme/plugins/parallax/index';  
import MoveFocus from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/plugins/move-focus/_move-focus';  
import CopyElementContent from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/plugins/copy-element-content/_copy-element-content';  
import DropdownSearch from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/plugins/dropdown-search/_dropdown-search';  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/node_modules/ui-theme/plugins/scrollToTarget/index';
  
import NoScroll from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/node_modules/ui-theme/plugins/no-scroll/index';  

//==================BEGIN COMPONENTS========================

import CookiePolicy from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/components/cookie-policy/cookie-policy';  
import SideMenu from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/components/side-menu/_side-menu';  
import Card from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/components/card/_card';  

//==================BEGIN WIDGETS========================

import ArticleMetrics from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/widgets/article-metrics/js/article-metrics';  
import Share from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/widgets/share/share';  
import ProfileMain from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/node_modules/ui-theme/widgets/profile-main/_profile-main';  
import PairingManagement from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/node_modules/ui-theme/widgets/pairing-management/_pairing-management';  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/node_modules/ui-theme/widgets/device-pairing/_device-pairing';
  
import Menu from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/widgets/menu/menu';  
import TrustedProxy from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/widgets/trusted-proxy/trusted-proxy';  
import Metrics from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/widgets/metrics/_metrics';  
import Recaptcha from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/node_modules/ui-theme/widgets/literatum/js/utilities/recaptcha';  

//==================BEGIN TEMPLATES========================

import ProfilePages from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/templates/profile-pages/profile-pages';  
import AuthorCenter from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/templates/author-center/author-center';  
import Landing from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/pnas/templates/landing/_landing';  

//==================BEGIN GROUPS========================

import './groups/_bootstrap';

import headerMain from './groups/_header';
const main = (UX) => {
    const $ManageUserMouse = Array.prototype.slice.call(document.querySelectorAll('body')),
        $Truncate = Array.prototype.slice.call(document.getElementsByClassName('authors-truncate')),
        $selectableDropdown = Array.prototype.slice.call(document.querySelectorAll('body')),
        $parralax = Array.prototype.slice.call(document.getElementsByClassName('parralax')),
        $noScroll = Array.prototype.slice.call(document.querySelectorAll('.js--add-noscroll, .js--remove-noscroll')),
        $Share = document.querySelector('.share'),
        $profileMain = document.querySelector('.profile-main'),
        $pairingManagement = document.querySelector('.pairing-management'),
        $Menu = document.getElementById('main-menu'),
        $TrustedProxy = Array.prototype.slice.call(document.getElementsByClassName('trusted-proxy-form')),
        $Metrics = document.getElementById('tab-metrics-inner'),
        $litRecaptcha = document.querySelector('.g-recaptcha'),
        $ProfilePages = document.querySelector('.profileMain'),
        $AuthorCenter = document.querySelector('.author-center__side-menu')

try {
        if ($ManageUserMouse.length ) {
            UX.ManageUserMouse = new ManageUserMouse($ManageUserMouse)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($Truncate.length ) {
            UX.Truncate = new Truncate($Truncate)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.a11y = new A11y().initialize()
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($selectableDropdown.length ) {
            UX.selectableDropdown = new SelectableDropdown($selectableDropdown).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($parralax.length ) {
            UX.parralax = $parralax
                .map(item=>new Parallax(item).initialize())
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.MoveFocus = new MoveFocus().initialize()
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.CopyElementContent = new CopyElementContent().initialize()
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.DropdownSearch = new DropdownSearch().initialize()
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($noScroll.length ) {
            UX.noScroll = new NoScroll().initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.CookiePolicy = new CookiePolicy().initialize()
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.SideMenu = new SideMenu().initialize()
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.card = new Card().initialize()
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.articleMetrics = new ArticleMetrics().initialize()
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($Share ) {
            UX.Share = new Share($Share)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($profileMain ) {
            UX.profileMain = new ProfileMain($profileMain)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($pairingManagement ) {
            UX.pairingManagement = new PairingManagement($pairingManagement)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($Menu ) {
            UX.Menu = new Menu($Menu).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($TrustedProxy.length ) {
            UX.TrustedProxy = new TrustedProxy($TrustedProxy).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($Metrics ) {
            UX.Metrics = new Metrics($Metrics).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($litRecaptcha ) {
            UX.litRecaptcha = new Recaptcha().initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($ProfilePages ) {
            UX.ProfilePages = new ProfilePages($ProfilePages).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($AuthorCenter ) {
            UX.AuthorCenter = new AuthorCenter($AuthorCenter)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.landing = new Landing().initialize()
    } catch (err) {
        console.error(err);
    }
    
headerMain(UX);

}
import './webpack-public-path'
const importPromises = async () => {

    
    const { default: dynamicMain } = await import(/* webpackChunkName: 'dynamic-imports' */ './dynamic-imports');
    const promises = Object.values(await dynamicMain(UX));
    

    
    promises.push(await import(/* webpackChunkName: 'requestidlecallback-polyfill' */ 'requestidlecallback-polyfill'));
    let lazyPromise = new Promise(resolve => {
        window.requestIdleCallback(
            async () => {
                const { default: lazyMain } = await import(/* webpackChunkName: 'lazy-imports' */ './lazy-imports');
                await lazyMain(UX);
                resolve();
            },
            { timeout: 5000 }
        );
    });
    

    promises.push(lazyPromise);

    return Promise.all(promises);
};

const build = async (UX) => {
    

    main(UX);
    await importPromises();
    undefined
};

build(UX).then(() => {
    console.debug('JS LOADED');
});

